// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__4OyRl"};